import { Routes, provideRouter } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { loginGuard } from './guard/login.guard';
import { roleGuard } from './guard/role.guard';
import { ticketsEnabledGuard } from './guard/tickets-enabled.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadComponent: () => import('./accountsManagment/login/login.component').then(m => m.LoginComponent),
        canActivate: [loginGuard]
    },
    {
        path: 'configuration',
        loadComponent: () => import('./accountsManagment/configuration/configuration.component').then(m => m.ConfigurationComponent),
        canActivate: [authGuard, roleGuard]
    },
    {
        path: 'home-page',
        loadComponent: () => import('./chats/home-page/home-page.component').then(m => m.HomePageComponent),
        canActivate: [authGuard]
    },
    {
        path: 'metrics',
        loadComponent: () => import('./metricsVisualization/metricsComponent/metrics.component').then(m => m.MetricsComponent),
        canActivate: [authGuard, roleGuard]
    },
    {
        path: 'facturacion',
        loadComponent: () => import('./facturacion/facturacion.component').then(m => m.FacturacionComponent),
        canActivate: [authGuard, roleGuard],
        title: 'Facturación'
    },
    {
        path: 'plantillas',
        loadComponent: () => import('./chats/plantillas/plantillas.component').then(m => m.PlantillasComponent),
        canActivate: [authGuard, roleGuard]
    },
    {
        path: 'difusion',
        loadComponent: () => import('./chats/difusion/difusion.component').then(m => m.DifusionComponent),
        canActivate: [authGuard, roleGuard]
    },
    {
        path: 'menus',
        loadComponent: () => import('./chats/menus/menus.component').then(m => m.MenusComponent),
        canActivate: [authGuard, roleGuard]
    },
    {
        path: 'tickets',
        loadComponent: () => import('./tickets/tickets.component').then(m => m.TicketsComponent),
        canActivate: [authGuard, ticketsEnabledGuard]
    },
    {
        path: 'privacy_policy',
        loadComponent: () => import('./Legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },
    {
        path: 'privacy-policy',
        loadComponent: () => import('./Legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
    },
    {
        path: 'delete_userdata',
        loadComponent: () => import('./Legal/delete-userdata/delete-userdata.component').then(m => m.DeleteUserdataComponent)
    },
    {
        path: 'delete-userdata',
        loadComponent: () => import('./Legal/delete-userdata/delete-userdata.component').then(m => m.DeleteUserdataComponent)
    },
    { 
        path: '**', redirectTo: 'login' 
    }
];

export const appRouter = provideRouter(routes);
